var e = /* @__PURE__ */ function() {
  function t(r) {
    this.f = r;
  }
  return t.prototype["@@transducer/init"] = function() {
    throw new Error("init not implemented on XWrap");
  }, t.prototype["@@transducer/result"] = function(r) {
    return r;
  }, t.prototype["@@transducer/step"] = function(r, n) {
    return this.f(r, n);
  }, t;
}();
function o(t) {
  return new e(t);
}
export {
  o as default
};
